import { BankOption } from '../../models/interfaces';

/**
 * Opciones de un <select> de bancos agrupadas por país (Costa Rica, Panamá...).
 * Si todos son del mismo país, se muestran sin grupo.
 */
const BankOptions = ({ banks }: { banks: BankOption[] }) => {
    const countries = Array.from(new Set(banks.map(bank => bank.countryName ?? 'Sin país')));

    if (countries.length <= 1) {
        return <>{banks.map(bank => <option key={bank.id} value={bank.id}>{bank.name}</option>)}</>;
    }

    return (
        <>
            {countries.map(country => (
                <optgroup key={country} label={country}>
                    {banks.filter(bank => (bank.countryName ?? 'Sin país') === country)
                        .map(bank => <option key={bank.id} value={bank.id}>{bank.name}</option>)}
                </optgroup>
            ))}
        </>
    );
};

export default BankOptions;
